/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite';
import '../style/canvas.scss'
import canvasState from '../store/canvasState';
import { CanvasType } from '../types/storeType';
import { Modal, Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import socketState from '../store/socketState';
import { getImg, postImg } from '../utils/fetchImg';
import { connectSockets } from '../utils/sockets';


const Canvas = observer(() => {
    const canvasRef = useRef<CanvasType>(null)
    const inputRef = useRef<HTMLInputElement | null>(null);
    const [modal, setModal] = useState<boolean>(true);
    const {id} = useParams();

    useEffect(() => {
        canvasState.setCanvas(canvasRef.current);
        getImg(id!)
    }, [])

    useEffect(() => {
        connectSockets(id!)
    }, [socketState.username])


    const mouseDownhandler = () => {
        if(canvasRef.current?.toDataURL()) {
            canvasState.pushToUndo(canvasRef.current.toDataURL())
        }
    }


    const connectionHandler = () => {
        socketState.setUsername(inputRef.current!.value);
        setModal(false);
    }

    return(
        <div className="canvas">
            <Modal show={modal} onHide={() => setModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Введите ваше имя</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <input type="text" ref={inputRef}/>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => connectionHandler()}>
                        Войти
                    </Button>
                </Modal.Footer>
            </Modal>
        
            <canvas 
                ref={canvasRef} 
                width={700} 
                height={500}
                onMouseDown={() => mouseDownhandler()}
                onMouseUp={() => postImg(id!)}
            />

        </div>
    )
})

export default Canvas;